import { useEffect, useState } from "react";
import { getModelo, getModeloCd } from "../../../services/apiModelo";
import { getCidade } from "../../../services/apiCidade";
import { getCondicao, getCondicaoCd } from "../../../services/apiCondicao";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getCategoria } from "../../../services/apiCategoria";
import { getImagensAnuncio } from "../../../services/apiImagem";
import { erroToastify } from "../../../shared/validacaoToastify";
import imagemPadrao from "../../../components/layout/rodape/M.svg";
import { deleteAnuncio, getAnuncio } from "../../../services/apiAnuncio";
import InputGenerico from "../../../components/inputGenerico/inputGenerico";
import SelectGenerico from "../../../components/selectGenerico/selectGenerico";
import { Form, FloatingLabel, Col, InputGroup, Tooltip, ToastContainer, } from "react-bootstrap";
import ModalDeConfirmacao from "../../../components/modal/modalDeConfirmacao/modalDeConfirmacao";
import ModalVisualizacaoImg from "../../../components/modal/modalVisualizacaoImg/modalVisualizacaoImg";

interface Anuncio {
  cdAnuncio: number;
  cdUsuario: number;
  cdCategoria?: number;
  cdModelo?: number;
  cdCidade: number;
  cdCondicao: number;
  dtPublicacao?: any;
  dmTipoAnuncio: boolean;
  dmAtivo: boolean;
  nmAnuncio: string;
  dsAnuncio: string;
  vlAnuncio: any;
  nrAnunciada: number;
  cdUsuarioInc: number;
  cdUsuarioAlt: number;
  dtInclusao: any;
  dtAlteracao: any;
  dmSituacao: boolean;
}

export default function ExcluirAnuncio() {
  const navigate = useNavigate();
  const { cdAnuncio } = useParams();
  const [urlVideo, setUrlVideo] = useState("");
  const [anuncio, setAnuncio] = useState<Anuncio>();
  const [imagens, setImagens] = useState<string[]>([]);
  const [showSpinner, setShowSpinner] = useState(false);
  const [modalImagem, setModalImagem] = useState(false);
  const [modalExcluir, setModalExcluir] = useState(false);
  const [linkAnuncio, setLinkAnuncio] = useState<string>();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [modelo, setModelo] = useState<{ cdModelo: number; nmModelo: string; }>();
  const [numeroImagensSelecionadas, setNumeroImagensSelecionadas] = useState(0);
  const [condicao, setCondicao] = useState<{ cdCondicao: number; nmCondicao: string; }>();
  const [cidade, setCidade] = useState<{ cdCidade: number; nmCidade: string; } | null>(null);
  const [categoria, setCategoria] = useState<{ cdCategoria: number; nmCategoria: string; }>();
  const [modalIsOpen, setModalIsOpen] = useState(false);


  const openModal = (index: number) => {
    setSelectedImageIndex(index);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleImageClick = (index: number) => {
    if (imagens[index]) {
      openModal(index);
    }
  };


  const formatCurrency = (value: string) => { return parseFloat(value).toLocaleString("pt-BR", { style: "currency", currency: "BRL", }); };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const renderTooltip = (message: string) => (
    <Tooltip
      id="tooltip"
      style={{ backgroundColor: "#d49a08", color: "black" }}
    >
      {message}
    </Tooltip>
  );
  const fetchCategoria = async () => {
    try {
      if (anuncio?.cdCategoria) {
        const response = await getCategoria(anuncio.cdCategoria);
        setCategoria(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchModelo = async () => {
    try {
      if (anuncio?.cdModelo) {
        const response = await getModeloCd(anuncio.cdModelo);
        setModelo(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchCidade = async () => {
    try {
      if (anuncio) {
        const response = await getCidade(anuncio.cdCidade.toString());
        setCidade(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchCondicao = async () => {
    try {
      if (anuncio?.cdCondicao) {
        const response = await getCondicaoCd(anuncio.cdCondicao);
        setCondicao(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchAnuncio = async (cd: any) => {
    try {
      const response = await getAnuncio(cd);
      setAnuncio(response);
    } catch (error) {
      console.error(error);
    }
  };
  const fetchImagens = async (anuncio: Anuncio) => {
    try {
      const response = await getImagensAnuncio(anuncio.cdAnuncio);
      if (response && response.length > 0) {
        const images = response.map(
          (image: any) =>
            `data:image/${image.nmTipoArquivo};base64,${image.mdArquivo}`
        );
        setImagens(images);

        const link = response.map((item: any) =>
          item.dsLinkVideo != null ? item.dsLinkVideo : null
        );

        setLinkAnuncio(link);
        setNumeroImagensSelecionadas(images.length);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleConfirmExclusao = () => {
    setShowConfirmation(true);
  };

  const cancelarExclusao = () => {
    setShowConfirmation(false);
  };
  const handleExcluir = async () => {
    try {
      const dataPresente = new Date();
      if (anuncio) {
        anuncio.cdUsuarioInc = 1;
        anuncio.cdUsuarioAlt = 1;
        anuncio.dtInclusao = dataPresente.toISOString();
        anuncio.dtAlteracao = dataPresente.toISOString();
        anuncio.dmSituacao = false;
        await deleteAnuncio(anuncio);
        const successMessage = "O anúncio foi excluído com sucesso!";
        navigate(
          `/milshop/usuario/meus-anuncios?successMessage=${encodeURIComponent(
            successMessage
          )}`
        );
      }
    } catch (error: any) {
      if (error.response.data) {
        erroToastify(error.response.data);
      }
    }
  };

  useEffect(() => {
    setShowSpinner(true);
    if (cdAnuncio) {
      try {
        fetchAnuncio(cdAnuncio);
      } catch {
       
      } finally {
        setShowSpinner(false);
      }
    }
  }, [cdAnuncio]);
  useEffect(() => {
    setShowSpinner(true);
    if (anuncio) {
      try {
        fetchCategoria();
        fetchModelo();
        fetchCidade();
        fetchCondicao();
        fetchImagens(anuncio);
      } catch {
       
      } finally {
        setShowSpinner(false);
      }
    }
  }, [anuncio]);

  if (showSpinner) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "40vh" }}
      >
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  const getImagemUrl = (index: number) => {
    const imagem = imagens[index];
    if (typeof imagem === 'string') {
      return imagem;
    }
    return '';
  };

  return (
    <form
      className="container containerAnuncio"
      encType="multipart/form-data"
      onSubmit={(e) => {
        e.preventDefault();
        handleConfirmExclusao();
      }}
    >
      <div className="ProdutoServico">
        {anuncio && (
          <div className="radio">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="produto"
                value="true"
                checked={anuncio.dmTipoAnuncio}
                disabled
              />
              <label
                className={`form-check-label ${anuncio.dmTipoAnuncio ? "produtoSelecionado" : "dermarcado"
                  } `}
                htmlFor="produto"
              >
                Produto
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="servico"
                value="false"
                checked={anuncio.dmTipoAnuncio === false}
                disabled
              />
              <label
                className={`form-check-label ${!anuncio.dmTipoAnuncio ? "servicoSelecionado" : "dermarcado"
                  }`}
                htmlFor="servico"
              >
                Serviço
              </label>
            </div>
          </div>
        )}
      </div>

      {/* BLOCO 01 */}
      {anuncio && (
        <div className="bloco01">
          {/* SUBBLOCO 01 */}
          <div className="estiloGeral subbloco01 shadow-sm p-3 bg-light rounded">
            <InputGenerico
              name="nmAnuncio"
              value={anuncio.nmAnuncio}
              label="Nome do Anúncio"
              placeholder="Digite aqui..."
              type="text"
              className={`form-control mt-0`}
              disabled={true}
            />
            <InputGenerico
              name="dtPublicacao"
              value={formatDate(anuncio.dtPublicacao)}
              label="Data de Publicação"
              placeholder="Digite aqui..."
              type="date"
              validacaoAtiva={true}
              className={`form-control`}
              disabled={true}
            />
            <div>
              <label htmlFor="vlAnuncio" className="mb-2">
                Valor
              </label>
              <InputGroup className={`mb-1`}>
                <InputGroup.Text>
                  {anuncio.vlAnuncio
                    ? formatCurrency(anuncio.vlAnuncio)
                    : "0,00"}
                </InputGroup.Text>
                <Form.Control
                  name="vlAnuncio"
                  value={anuncio.vlAnuncio}
                  aria-label="Dollar amount (with dot and two decimal places)"
                  type="number"
                  step="0.010"
                  placeholder="Digite aqui..."
                  id="vlAnuncio"
                  min={0}
                  disabled={true}
                />
              </InputGroup>
            </div>
            <SelectGenerico
              opcoes={[
                {
                  valor: cidade?.cdCidade ?? "",
                  rotulo: cidade?.nmCidade ?? "",
                },
              ]}
              valorSelecionado={anuncio.cdCidade}
              label="Cidade"
              opcaoPadrao="Selecione a cidade..."
              classe={`form-select mt-0 dropdown-content`}
              disabled={true}
            />
          </div>
          {/* SUBBLOCO 02 */}
          <>
            {anuncio.dmTipoAnuncio === true && (
              <div
                className={`mt-3 estiloGeral subbloco02 shadow-sm p-3 bg-light rounded`}
              >
                <SelectGenerico
                  opcoes={[
                    {
                      valor: categoria?.cdCategoria ?? "",
                      rotulo: categoria?.nmCategoria ?? "",
                    },
                  ]}
                  valorSelecionado={anuncio.cdCategoria}
                  label="Categoria"
                  opcaoPadrao="Selecione a categoria..."
                  classe={`form-select mt-0 dropdown-content`}
                  disabled={true}
                />
                <SelectGenerico
                  opcoes={[
                    {
                      valor: modelo?.cdModelo ?? "",
                      rotulo: modelo?.nmModelo ?? "",
                    },
                  ]}
                  valorSelecionado={anuncio.cdModelo}
                  label="Modelo"
                  opcaoPadrao="Selecione o modelo..."
                  classe={`form-select mt-0 dropdown-content`}
                  disabled={true}
                />
                <SelectGenerico
                  opcoes={[
                    {
                      valor: condicao?.cdCondicao ?? "",
                      rotulo: condicao?.nmCondicao ?? "",
                    },
                  ]}
                  valorSelecionado={anuncio.cdCondicao}
                  label="Condição"
                  opcaoPadrao="Selecione a condição..."
                  classe={`form-select mt-0 dropdown-content`}
                  disabled={true}
                />
                <InputGenerico
                  name="nrAnunciada"
                  value={anuncio.nrAnunciada}
                  placeholder="informe a quantidade..."
                  type="number"
                  className={`form-control mt-0`}
                  label="Quantidade"
                  min="0"
                  disabled={true}
                />
              </div>
            )}
          </>
        </div>
      )}
      {/* BLOCO02 */}
      {anuncio && (
        <div className="bloco02 estiloGeral mt-3 shadow-sm p-3 bg-light rounded">
          <div>
            <div className="containerImagens mt-3">
              {[...Array(5)].map((_, index) => {
                return (
                  <div
                    className={`imagemAnuncio ${imagens[index] ? "temImagem" : "imagemPadrao"
                      }`}
                  >
                    <img
                      src={imagens[index] ? imagens[index] : imagemPadrao}
                      alt={`Imagem ${index}`}
                      onClick={() => handleImageClick(index)}
                    />
                  </div>
                );
              })}
            </div>

            {imagens.length ? (
              <div className="avisoImagens d-flex mt-2 gap-1"></div>
            ) : (
              ""
            )}
          </div>
          <div>
            <Col sm={12}>
              <FloatingLabel
                controlId="floatingTextarea2"
                label="Descrição"
                className="mt-2"
              >
                <Form.Control
                  value={anuncio.dsAnuncio}
                  as="textarea"
                  name="dsAnuncio"
                  placeholder="Leave a comment here"
                  style={{ height: "200px", resize: "none" }}
                  disabled={true}
                />
              </FloatingLabel>
            </Col>
          </div>
        </div>
      )}
      <div className="botoes mt-3">
        <Link
          className="btn btn-outline-danger me-2 btn-sm"
          to="/milshop/usuario/meus-anuncios"
          role="button"
          style={{ width: "100px" }}
        >
          Cancelar
        </Link>
        <button
          type="submit"
          className="btn btn-outline-warning btn-sm"
          style={{ width: "100px" }}
        >
          Excluir
        </button>
      </div>
      <ModalVisualizacaoImg
        getImagemUrl={getImagemUrl}
        selectedImageIndex={selectedImageIndex}
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
      />
      <ToastContainer />
      <ModalDeConfirmacao
        showConfirmation={showConfirmation}
        confirmExclusao={handleExcluir}
        cancelarExclusao={cancelarExclusao}
        textoExclusao="Deseja realmente excluir este anúncio?"
      />
    </form>
  );
}
